export enum NoteType {
  Important = 'important',
  Warning = 'warning',
  Information = 'information',
  Suggestion = 'suggestion',
  Praise = 'praise',
  Progress = 'progress',
}
